<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending }"
  fxLayout="row"
  appMargin
  marginT="5"
  appPadding="0"
  fxLayoutAlign="start center"
  fxLayoutGap="64px"
>
  <div
    class="parent"
    fxLayout="row"
    fxLayoutGap="12px"
    fxLayoutAlign="start center"
    style="width: 100%;"
  >
    <div>
        <sui-checkbox> </sui-checkbox>
    </div>

    <div
      fxLayout="column"
      fxLayoutGap="12px"
    >
      <div class="row-1">
        {{ getEquipmentTypeName(equipment?.equipTypeId) }}
      </div>
      <div class="row-2">
        {{ equipment?.equipName }}
      </div>
      <div class="row-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="35px">
        <div class="content" fxFlex="100px">
          <div class="top">Model Number</div>
          <div class="bottom">
            {{ equipment?.equipModelNumber }}
          </div>
        </div>
        <div class="content" fxFlex="120px">
          <div class="top">Year of Manufacture</div>
          <div class="bottom">
            {{ equipment?.yearOfManufacture }}
          </div>
        </div>
        <div class="content" fxFlex="150px">
          <div class="top">Date Added</div>
          <div class="bottom">
            {{ equipment?.dateCreated | date }}
          </div>
        </div>
        <div class="content" fxFlex="200px">
          <div class="top">Added By</div>
          <div class="bottom">
            {{ equipment?.createdBy | createdBy }}
          </div>
        </div>
      </div>
    </div>

    <div fxFlex="25%" fxLayout="row" fxLayoutAlign="end center" class="text-right">
          <button
            appMargin
            marginX="10px"
            *isPermitted="{ id: 'EQUIPMENT_MANAGEMENT', action: 'edit' }"
            class="ui circular tiny button"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            popupText="edit"
            (click)="editEquipment.emit(equipment)"
          >
            <!-- <i class="pencil icon"></i> -->
            <img class="pencil icon"  src="../../../../../../../../assets/icons/edit.svg" alt="pencil">
          </button>
          <button
            *isPermitted="{ id: 'EQUIPMENT_MANAGEMENT', action: 'remove' }"
            class="ui circular tiny button"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            popupText="archive"
            (click)="onRestoreModal.emit(equipment)"
          >
            <!-- <i class="archive icon"></i> -->
            <img class="archive icon"  src="../../../../../../../../assets/icons/archive_24px.svg" alt="archive">
          </button>
          <!-- <button
            class="ui circular tiny button"
            (click)="toggleEquipment()"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            [popupText]="collapseEquipment ? 'Expand' : 'Collapse'"
          >
            <i
              [ngClass]="
                collapseEquipment ? 'chevron down icon' : 'chevron up icon'
              "
            ></i>
          </button> -->
        </div>
  </div>
  <!-- <div [suiCollapse]="collapseEquipment">
    <div
      class="ui vertical basic segment"
      [ngClass]="{ loading: pending }"
      appMargin="0"
      appPadding="0"
    >
      <div
        class="ui segment"
        appMargin
        marginB="3"
        fxLayout="column"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="40%" style="font-weight: bold">YEAR OF MANUFACTURE</div>
        <div fxFlex="40%">{{ equipment?.yearOfManufacture }}</div>
      </div>
    </div>
  </div> -->
</div>
<div class="ui divider"></div>
